<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog custom-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('projects.label.last_comment') }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
          </div>
        </div>
        <div class="modal-body"> 
          <div v-html="contentValue"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {ref, watch} from "vue";

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    comment: {
      type: String,
      default: ''
    },
  })

  const contentValue = ref(props.comment)

  watch(() => props.comment, (newVal) => {
    contentValue.value = newVal
  })

  function closeModal(){
      $('#'+props.id).modal('toggle')
  }
</script>
    
<style scoped>
  .custom-modal {
    position: fixed;
    top: 10%;
    left: 40%;
    width: 500px !important;
  }
</style>